let platform = 'web'; // web, android, ios
let provider = 'web'; // web, google, huawei, amazon, ios

function setPlatform(newPlatform) {
  platform = newPlatform;
}

function getPlatform() {
  return platform;
}

function setProvider(newProvider) {
  provider = newProvider;
}

function getProvider() {
  return provider;
}

module.exports = {
  setPlatform,
  getPlatform,
  setProvider,
  getProvider,
};
